import * as React from 'react';

// tslint:disable:max-line-length
export const GasIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16">
    <g fillRule="nonzero">
      <path d="M8.5 16h-3a.5.5 0 0 1-.5-.5v-.589l-3.576-.7A1.6 1.6 0 0 1 0 12.613V11h14v1.61a1.621 1.621 0 0 1-1.48 1.608L9 14.911v.589a.5.5 0 0 1-.5.5zM6.212 0A4.151 4.151 0 0 1 5.1 2.634C4.1 3.586 3 4.519 3 6a3.982 3.982 0 0 0 2.085 3.491C5.466 8.38 7 7.821 7 6.555a4 4 0 0 1 1.964 2.91A3.983 3.983 0 0 0 11 6a7.373 7.373 0 0 0-4.788-6z" />
    </g>
  </svg>
);
